import React, { useEffect, useState } from "react";
import CheckBox from "../../Fields/CheckBox";
import { useTranslation } from "react-i18next";
import TextInput from "../../Fields/TextInput";
import Button from '@material-ui/core/Button';
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import Tooltip from "@material-ui/core/Tooltip";


const SearchSubmitOptions = (props) =>{
   
    const history = useHistory();
    const toggle = useSelector(state => state.setToggle.toggle);
    
    const { t, i18n } = useTranslation('common');

    const {formJson, setFormJson, submitSearch, saveTemplate, canSubmitSearch = true} = props

    const [saveFormCheckbox, setSaveFormCheckbox] = useState(false);
    const [isSubmitActive, setIsSubmitActive] = useState(false);
    
    useEffect(()=>{
        const hasNoErrors = formJson.layout.errorIdList.length === 0;
        setIsSubmitActive(hasNoErrors && canSubmitSearch === true);

        if(formJson.searchInfo.bypass_ft == null){
            formJson.searchInfo.bypass_ft = false;
            setFormJson({...formJson});
        }

    },[formJson, canSubmitSearch])

    function homeRedirect() {
        history.push("/home");
    }

    function scrolltoError() {
        const errorId = formJson.layout.errorIdList[0];
        if (!errorId) return;
        document.getElementById(errorId)?.scrollIntoView({ behavior: "smooth" });
        formJson.layout.errorsActive = true;
        setFormJson({...formJson});
    }

    return(
        <div>
            <div style={{width: "100%", display: "flex", alignItems: "center"}}>
                <Tooltip title={"Skip Discover text indexing to speed up the search, especially when searching for more than 100,000 alignments"} placement="right" arrow disableFocusListener> 
                <span>
                <CheckBox
                    // defaultChecked
                    color="primary"
                    name="createFt"
                    id="createFt"
                    onChange={(e) => { 
                        let val = e.target.checked;
                        formJson.searchInfo.bypass_ft = val;
                        setFormJson({...formJson});

                    }}
                    checked={formJson.searchInfo.bypass_ft === true}
                />
                <label className={"bodyText cursorPointer"} style={{marginTop: "8px"}} htmlFor="createFt">{t("createFt")}</label>
                </span>
                </Tooltip>
            </div>
            <div style={{width: "100%", display: "flex", alignItems: "center"}}>
                <CheckBox
                    // defaultChecked
                    color="primary"
                    id="check"
                    onChange={(e) => { 
                        let val = e.target.checked;

                        if(val){
                            formJson.searchInfo.send_email = "on"
                        }else{
                            formJson.searchInfo.send_email = ""
                        }
                        setFormJson({...formJson})
                    }}
                    checked={formJson.searchInfo.send_email === "on"}
                />
                <label className={"bodyText cursorPointer"} style={{marginTop: "8px"}} htmlFor="check">{t("sendMailAfterSearch")}</label>
            </div>
                    
            <div style={{width: "100%", display: "flex", alignItems: "center"}}>
                <CheckBox
                    // defaultChecked
                    color="primary"
                    id="saveForm"
                    onChange={(e)=>{
                        let val = e.target.checked;
                        if(!val){
                            formJson.searchInfo.is_default = false;
                        }else{
                            if( formJson.searchInfo.template_name === ""){
                                formJson.layout.errorIdList.push("formTemplateName")
                            }
                        }
                        setFormJson({...formJson})
                        setSaveFormCheckbox(val)
                    }}
                    checked={saveFormCheckbox}
                />
                <label className={"bodyText cursorPointer"} style={{marginTop: "8px", paddingRight: "15px"}} htmlFor="saveForm">{t("SaveFormForlaterUse")}</label>
                <div style={{width: "450px", paddingRight: "15px"}}>
                    <div style={{position: "absolute", width: "440px", marginTop: "-20px"}}>
                    <TextInput
                        spellCheck="false"
                        id="formTemplateName"
                        label="Name the form"
                        variant="outlined"
                        onChange={(e) => {
                            let value = e.currentTarget.value
                            if(value === ""){
                                formJson.layout.errorIdList.push("formTemplateName")
                            }else{
                                formJson.layout.errorIdList = formJson.layout.errorIdList.filter(id => id !== "formTemplateName")
                            }
                            formJson.searchInfo.template_name = value;
                            
                            setFormJson({...formJson})
                        }}
                        fullWidth={true}
                        helperText={formJson.layout.errorIdList.includes("formTemplateName") && formJson.layout.errorsActive ? "Template name is required" : ""}
                        disabled={!saveFormCheckbox}
                        value={formJson.searchInfo.template_name}
                        error={formJson.layout.errorIdList.includes("formTemplateName") && formJson.layout.errorsActive}
                        
                    />
                    </div>
                </div>
            
                {saveFormCheckbox ? (
                    <Button className="accountInfo" onClick={()=>{
                        saveTemplate();
                    }}>
                        {t("saveTemplate")}
                    </Button>
                ) : (
                    <Button className="cancelButtonDisable" disabled>
                        {t("saveTemplate")}
                    </Button>
                )}
            </div>
            <div style={{width: "100%", display: "flex", alignItems: "flex-start", marginTop: "8px"}}>
            <CheckBox
                // defaultChecked
                color="primary" 
                className={""}
                name="checkDefault"
                id="checkDefault"
                onChange={(e) => {
                    formJson.searchInfo.is_default = !formJson.searchInfo.is_default 
                    setFormJson({...formJson})
                }}
                checked={formJson.searchInfo.is_default}
                disabled={!saveFormCheckbox}
                style={{ color: (toggle ? '': '#aea9a9' )}}
            />

            <label className={"bodyText cursorPointer"} style={{marginTop: "4px", width: "400px"}} htmlFor="checkDefault">
                {t("defaultsave")}
            </label>

            <div style={{ 
                display: "flex",
                width: "100%",
                height: "60px",
                justifyContent: "flex-end",
                alignItems: "flex-end"
                }}>
                <Button 
                    style={{ backgroundColor: '#0182C5',
                            borderColor: '#1F4E79',
                            border: '1px solid #1F4E79',
                            color: 'white',
                            margin: "4px",
                            textTransform: 'capitalize',
                            '&:hover': {
                                backgroundColor: '#0182C5',
                                boxShadow: 'none',
                            },}} 
                    onClick={()=>{homeRedirect()}}
                >
                    {t("cancel")}
                </Button>
                {isSubmitActive && 
                    <Button className="accountInfo" onClick={submitSearch}>
                        {t("submit")}
                    </Button>
                }
                {!isSubmitActive && 
                    <Button className="cancelButtonDisable" disabled onClick={()=>{scrolltoError()}}>
                        {t("submit")}
                    </Button>
                }
            </div>
            </div>

        </div>
    )


}

export default SearchSubmitOptions